export class FastBrideConstant {
    static redMaxValue: number = 20;
    static yellowMaxValue: number = 30;
    static greenMaxValue: number = 85;
}

export class GeneralConstant {
    static emptyJson: string = "{}";
    static intercomInfoKey: string = "useIntercomInfo";
}